import { useState } from 'react';
import { useHistory } from 'react-router';
import { Box, Typography } from '@mui/material';
// Our Components
import FirstStepLogin from './FirstStepLogin';
import SecondStepLogin from './SecondStepLogin';
// Utils and Helpers
import { APP_ROUTES } from 'routes';
// Assets
import PaystandLogo from 'assets/authentication/LogoInicio.svg';
import './FormSection.css';

const FormSection = ({ loginError, isLoading, setIsLoading }) => {
    const history = useHistory();
    const [step, setStep] = useState(false);

    const nextStep = () => {
        setStep(!step);
    };

    return (
        <Box className="form-section">
            <Box marginRight="4em">
                <img src={PaystandLogo} alt={'paystand-logo'} />
            </Box>
            <Box>
                {step ? (
                    <SecondStepLogin previousStep={nextStep} />
                ) : (
                    <FirstStepLogin
                        nextStep={nextStep}
                        loginError={loginError}
                        isLoading={isLoading}
                        setIsLoading={setIsLoading}
                    />
                )}
                <Box className="signup-link-container">
                    <Typography variant="label">
                        Don’t have an account?
                        <label className="signup-link" onClick={() => history.push(APP_ROUTES.SIGNUP)}>
                            &nbsp; Sign Up
                        </label>
                    </Typography>
                </Box>
            </Box>
        </Box>
    );
};

export default FormSection;
